/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicalConsultant } from './MedicalConsultant';
import {
    MedicalConsultantFromJSON,
    MedicalConsultantFromJSONTyped,
    MedicalConsultantToJSON,
} from './MedicalConsultant';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface MedicalConsultantPagination
 */
export interface MedicalConsultantPagination {
    /**
     * 
     * @type {Array<MedicalConsultant>}
     * @memberof MedicalConsultantPagination
     */
    data?: Array<MedicalConsultant>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof MedicalConsultantPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the MedicalConsultantPagination interface.
 */
export function instanceOfMedicalConsultantPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MedicalConsultantPaginationFromJSON(json: any): MedicalConsultantPagination {
    return MedicalConsultantPaginationFromJSONTyped(json, false);
}

export function MedicalConsultantPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalConsultantPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(MedicalConsultantFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function MedicalConsultantPaginationToJSON(value?: MedicalConsultantPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(MedicalConsultantToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

